const BASE_URL = "/api/manage";

const COMPANY_URLS = {
  GET_ALL: `${BASE_URL}/companies`,
  GET_ONE: `${BASE_URL}/companies/`,  // append id
  INSERT: `${BASE_URL}/companies`,
  UPDATE: `${BASE_URL}/companies/`,  // append id
  DELETE: `${BASE_URL}/companies/delete/`,  // append id
  GET_INDICES: `${BASE_URL}/indices`,
  STATUS_UPDATE: `${BASE_URL}/companies/toggle-status/`,
};

const SECTOR_URLS = {
  GET_ALL: `${BASE_URL}/sectors`,
  GET_ONE: `${BASE_URL}/sectors/`,  // append id
  INSERT: `${BASE_URL}/sectors`,
  UPDATE: `${BASE_URL}/sectors/`,  // append id
  DELETE: `${BASE_URL}/sectors/delete/`,  // append id
};

const INDEX_COMPANY_URLS = {
  GET_ALL: `${BASE_URL}/index-companies`,
  GET_BY_INDEX: `${BASE_URL}/index-companies/index/`,  // append index_id
  INSERT: `${BASE_URL}/index-companies`,
  DELETE: `${BASE_URL}/index-companies/delete/`,       // append record id (PK)
  DELETE_ALL: `${BASE_URL}/index-companies/delete-all/`, // append index_id
  GET_ALL_SELECT: `${BASE_URL}/entities/select`,
};
const HOLIDAYS_URLS = {
  GET_ALL: `${BASE_URL}/holidays`,
  GET_ONE: `${BASE_URL}/holidays/`,
  INSERT: `${BASE_URL}/holidays`,
  UPDATE: `${BASE_URL}/holidays/`,
  DELETE: `${BASE_URL}/holidays/delete/`,
};

const AI_PROMPTS_URLS = {
  GET_ALL: `${BASE_URL}/ai-prompts`,
  GET_ONE: `${BASE_URL}/ai-prompts/`,  // append id
  GET_BY_NAME: `${BASE_URL}/ai-prompts/name/`,  // append name
  INSERT: `${BASE_URL}/ai-prompts`,
  UPDATE: `${BASE_URL}/ai-prompts/`,  // append id
  DELETE: `${BASE_URL}/ai-prompts/delete/`,  // append id
};

export { COMPANY_URLS, SECTOR_URLS, INDEX_COMPANY_URLS, HOLIDAYS_URLS, AI_PROMPTS_URLS };
